import React from 'react';
import SignUp from '../../components/SignUp/SignUp';
import SecurityLayout from '../../layout/SecurityLayout';

const SignUpPage: React.FC = () => {
  return (
    <SecurityLayout>
      <SignUp />
    </SecurityLayout>
  );
};

export default SignUpPage;
